// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"1722d957","329":"a628bcfd","863":"c0052a7b"}[chunkId] + ".chunk.css";
};